import { useEffect } from 'react';
import { useStoreConfig } from '../context/StoreConfigContext.jsx';


export function usePageTitle(pageTitle) {
  const { site } = useStoreConfig();

  useEffect(() => {
    document.title = pageTitle ? `${site.name} | ${pageTitle}` : site.name;
  }, [site.name, pageTitle]);
}
